import React, {FormEvent, useEffect, useState} from "react";
import {Input, PageHeader, Textarea, VideoComponent} from "../../components";
import {Grid, useMediaQuery} from "@material-ui/core";
import StepWizard from "react-step-wizard";
import {Rating} from 'react-simple-star-rating'
import {supabase} from "../../services/supabase.service";
import {useParams} from "react-router-dom";

import warningIcon from "../../assets/images/icons/warning.svg";
import "./styles.css";

function EvaluationForm() {

    const breakpoint = useMediaQuery('(min-width:600px)', {noSsr: true});


    const [avaliations, setAvaliations] = useState<any>([]);
    const [student, setStudent] = useState<any>();
    const [evaluator, setEvaluator] = useState<any>(null);
    const [evaluatorEmail, setEvaluatorEmail] = useState<string>("");
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");
    const [allStudents, setAllStudents] = useState<any>([])
    const [studentIndex, setStudentIndex] = useState(0)
    const [counter, setCounter] = React.useState(0)
    const [edition, setEdition] = useState<any>({})

    // @ts-ignore
    const { id } = useParams();

    useEffect(() => {
        (async () => {
            console.log('id changed', id)

            //get edition data
            if (id) {
                await supabase.from('editions').select('*').eq('edition_number', id)
                    .then(({data, error}) => {
                        if(data)
                            setEdition(data[0])
                        return false
                    })
            }

            const evaluatorLocal = JSON.parse(
                window.localStorage.getItem("evaluator") || "{}"
            );

            console.log('loaded1', evaluatorLocal)

            if (window.localStorage.getItem("evaluator") !== null) {
                console.log('loaded')
                getCriterias();
                setEvaluator(evaluatorLocal);
                getStudents(id, evaluatorLocal.grupo, evaluatorLocal.id).then((s: any) => {
                })
            } else {
                setLoading(false)
            }
        })();
    }, [id]);

    async function getCriterias() {

        supabase.from('edition_criteria')
            .select('*').eq('edition', edition.edition_number).then(({data, error}) => {

            if (data) {
                data = data.map((criterion: any) => {
                    return {...criterion, evaluation: 0, comment: ""}
                })

                setAvaliations(data);
            }
        }, error => {
            console.log(error)
        });

    }

    async function getStudents(edition_id:any,groupID: any, evaluatorID: any) {
        console.log('edition', edition_id)
        const {data} = await supabase
            .from('eval_students')
            .select(`*`)
            .eq('group_id', groupID)
            .eq('edicao', edition_id)


        setAllStudents(data)

        const {data: evaluations} = await supabase
            .from('evaluations')
            .select(`id,evaluation,student_id, evaluatorid, edition`)
            .eq('edition', edition_id).eq('evaluatorid', evaluatorID)

        const my_students: any[] = [];

        if (data && evaluations) {
            data.map((student: any) => {
                let evals = evaluations.filter((evaluation: any) => evaluation.student_id === student.id && evaluation.evaluatorid === evaluatorID)
                if (evals.length === 0) {
                    my_students.push(student)
                }
                return student
            })
        }


        if (data && my_students && my_students.length > 0) {

            let StudentIndex = data.findIndex((a: any) => a.id === my_students[0].id)
            console.log(StudentIndex)
            setStudentIndex(StudentIndex);
            setStudent(my_students[0]);
            setLoading(false);
            setMessage("");

        } else {
            console.log('no students')
            setMessage("Você já avaliou todas as alunas da sua amostra. Muito obrigada pelo seu tempo e dedicação. ❤️");
            localStorage.removeItem("evaluator");
            setLoading(false);
            setStudent(false);
        }
    }

    useEffect(() => {
        getCriterias();
    }, [allStudents])


    async function loginEvaluator(e: FormEvent) {

        e.preventDefault();

        const email = evaluatorEmail.trim();

        const {data: evaluator_res} : any = await supabase
            .from('evaluators')
            .select(`*`)
            .eq('email', email).eq('edicao', edition.edition_number)

        if (evaluator_res) {
            setEvaluator(evaluator_res[0]);
            localStorage.setItem("evaluator", JSON.stringify(evaluator_res[0]));
            await getStudents(edition.edition_number, evaluator_res[0]["grupo"], evaluator_res[0]["id"]);
            setLoading(false);
        } else {
            alert("Email não encontrado, verifique por favor.");
        }

    }


    const evaluateStudent = async () => {
        setMessage("Salvando...")
        setLoading(true);

        const validate_votes = avaliations.findIndex((avaliation: any) => (!avaliation.evaluation))
        console.log("avaliations", avaliations, validate_votes)
        if (validate_votes !== -1) {

            alert("Por favor preencha todas as avaliações  e comentários")
            setMessage("")
            setLoading(false);

            return false;
        }

        try {
            let input: any = []

            avaliations.map((avaliation: any) => input.push(
                {
                    student_id: student.id,
                    evaluatorid: evaluator.id,
                    evaluation: avaliation.evaluation,
                    comment: avaliation.comment,
                    edition: edition.edition_number
                })
            );

            await supabase.from('evaluations').insert(input)

            setCounter(0)
            await getStudents(edition.edition_number, evaluator.grupo, evaluator.id)
            const avaliations_items = avaliations.map((criterion: any) => {
                return {...criterion, evaluation: 0, comment: ""}
            })
            setAvaliations(avaliations_items)
            return;

        } catch (error) {

            alert("Falha ao computar voto. Tente novamente.");
            setMessage("")
            return false;

        }
    }


    const handleEvaluation = (index: any, e: any) => {
        avaliations[index - 1].comment = e.comment;
        avaliations[index - 1].evaluation = e.evaluation;
        setAvaliations(avaliations);

    };


    return (
        <>
            <div id="page-teacher-form" className="container">
                <PageHeader
                    title="Banca de Avaliação de Candidatas"
                    description={`Bem-vinda a Avaliação da Seleção de Candidatas do ${edition.title}. Antes de avaliar, confira com atenção a candidatura, pontue observando o critério estabelecido e justifique sua nota.`}
                />

                <main>
                    {loading && (
                        <fieldset>
                            <legend>Aguarde...</legend>
                        </fieldset>
                    )}
                    {message && (
                        <fieldset>
                            <legend>{message}</legend>
                        </fieldset>
                    )}
                    {!loading && !evaluator && (
                        <form onSubmit={loginEvaluator}>

                            <fieldset>
                                <legend>Olá avaliadora, por favor se identifique</legend>

                                <Input
                                    name="email"
                                    label="E-mail"
                                    placeholder="Email utilizado no cadastro"
                                    onChange={(e: any) => setEvaluatorEmail(e.target.value.trim())}
                                />
                            </fieldset>

                            <footer>

                                <button type="submit">Prosseguir</button>

                            </footer>
                        </form>
                    )}
                    {!loading && evaluator && student && (evaluator.id && student.id) && (
                        <form autoComplete="off">
                            <Grid container>
                                <Grid item lg={12} md={12} sm={12} xs={12} style={{textAlign: 'center'}}>

                                    <h3>Olá {evaluator.name}, você está avaliando:</h3>
                                </Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12} style={{textAlign: 'center'}}>

                                    <div className="progress-bar">
                                        <div className="progress"
                                             style={{width: `${(((studentIndex + 1) / allStudents.length) * 100)}%`}}></div>
                                    </div>

                                </Grid>
                            </Grid>
                            <Grid container style={{margin: '10px 0'}}>

                                <Grid item lg={11} md={11} sm={11} xs={11}>
                                    <h4>{student.name} </h4>

                                </Grid>
                                <Grid item lg={1} md={1} sm={1} xs={1}>

                                    <h4 style={{color: "red"}}>{`${studentIndex + 1}/${allStudents.length}`}</h4>

                                </Grid>
                            </Grid>
                            <Grid container direction={!breakpoint ? "row" : "row-reverse"} spacing={2}>
                                <Grid item lg={6} md={6} sm={12} xs={12}>

                                    {student.format.trim() === "text" && (

                                        <Textarea
                                            name="text_video"
                                            label=""
                                            value={student.text.trim()}
                                            readOnly
                                            style={{padding: '5px', borderRadius: 5}}
                                        />
                                    )}

                                    {student.format.trim() === "video" && (
                                        <VideoComponent label="" value={student.video.trim()}
                                                        style={{backgroundColor: '#000', padding: '5px', borderRadius: 5}}/>
                                    )}

                                </Grid>
                                <Grid item lg={6} md={6} sm={12}>

                                    <StepWizard
                                        isLazyMount={student.length}
                                    >
                                        {avaliations.length && avaliations.map((avaliation: any, i: number) => (

                                            <First key={Math.random()} label={avaliation.title}
                                                   vote={(form: any, step: number, vote: number) => {
                                                       handleEvaluation(step, form)
                                                   }} description={avaliation.description} counter={counter}
                                                   avaliation={avaliation} avaliations={avaliations}
                                                   update={handleEvaluation} evaluateStudent={evaluateStudent}/>

                                        ))}

                                    </StepWizard>
                                </Grid>
                            </Grid>
                            <footer>
                                <p>
                                    <img src={warningIcon} alt="Aviso importante"/>
                                    Importante! <br/> Preencha todos os dados
                                </p>
                            </footer>
                        </form>
                    )}
                </main>
            </div>
        </>
    );
}


/**
 * Stats Component - to illustrate the possible functions
 * Could be used for nav buttons or overview
 */
interface StatsProps {
    currentStep: any
    firstStep: any
    goToStep: any
    lastStep: any
    nextStep: any
    previousStep: any
    totalSteps: any
    step: any
    finish: any
}

const Stats = ({
                   currentStep,
                   firstStep,
                   goToStep,
                   lastStep,
                   nextStep,
                   previousStep,
                   totalSteps,
                   step,
                   finish
               }: StatsProps) => {
    return (
        <Grid container direction="row" justifyContent="flex-end" alignItems="center">
            {currentStep > 1 &&
                <button type="button" style={{marginRight: 10}} onClick={previousStep}>&#60;</button>
            }
            {currentStep < totalSteps ?
                <button type="button" className='btn btn-primary btn-block' onClick={nextStep}>Próximo</button>
                :
                <button type="button" className='btn btn-success btn-block' onClick={finish}>Concluir</button>
            }
        </Grid>
    )
};

/** Steps */

const First = (props: any) => {
    const [form, setForm] = React.useState(props.avaliation)
    const [counter, setCounter] = React.useState(props.counter || 0)
    const [avaliations, setAvaliations] = React.useState(props.avaliations || []);

    const validate = async (step: number, values: any) => {
        console.log('form', form)

        if(!form.evaluation)
            return alert('Informe uma nota para sua avaliação')

        //if(!form.comment)
            //return alert('Informe um comentário para sua avaliação')

        props.update(props.currentStep, form)

        if (step < 3)
            return props.nextStep();

        props.evaluateStudent()

    };

    const rate = (value: number) => {
        const updatedAvaliations = [...props.avaliations];
        updatedAvaliations[props.currentStep - 1].evaluation = value;

        const sumValues = updatedAvaliations.reduce((a: any, b: any) => +a + +b.evaluation, 0);
        console.log('sumValues', sumValues, value);

        setAvaliations(updatedAvaliations);
        setForm({...form, evaluation: value});
        setCounter(sumValues);
    }

    return (
        <>
            <Grid container style={{borderBottom: '1px solid #CCC', paddingTop: '15px'}}>
                <Grid item xs={10} lg={10}>
                    <b>Critérios</b>
                </Grid>
                <Grid item xs={2} lg={2}>
                    {props.currentStep} de 3
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs={12} lg={12}>
                    <b className="question-title">{props.label}</b>
                </Grid>
                <Grid item xs={12} lg={12}>
                    <Rating onClick={(value: any) => {
                        rate(value)
                    }} fillColor="#D31244" ratingValue={form.evaluation} /* Rating Props */ >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" fill='currentColor' height="24"
                             viewBox="0 0 24 24">
                            <path
                                d="M12 4.435c-1.989-5.399-12-4.597-12 3.568 0 4.068 3.06 9.481 12 14.997 8.94-5.516 12-10.929 12-14.997 0-8.118-10-8.999-12-3.568z"/>
                        </svg>
                    </Rating>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item lg={12}>
                    <span style={{fontSize: '13px', color: '#333'}}
                            dangerouslySetInnerHTML={{__html: props.description}}></span>
                </Grid>
                <Grid item lg={12} xs={12}>
            <textarea name="comment" placeholder="Suas considerações... (Opcional)" rows={3} onChange={(e: any) => {
                setForm({...form, [e.target.name]: e.target.value})
            }
            } className="reason" value={form.comment}></textarea>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item lg={6} xs={6} style={{lineHeight: '50px'}}>
                    Total: <input type="text"
                                  id="average"
                                  disabled
                                  size={4}
                                  style={{marginLeft: 0}}
                                  value={parseInt(counter)}
                />
                </Grid>
                <Grid item lg={6} xs={6}>
                    <Stats step={1} {...props} nextStep={(event: any) => {
                        validate(props.currentStep, form)
                    }} finish={(event: any) => {
                        validate(props.currentStep, form)
                    }}/>
                </Grid>
            </Grid>
        </>
    );
};


export default EvaluationForm;
